import { MutableRefObject } from 'react';

export const getSelectedMentionItem = (containerRef: MutableRefObject<HTMLDivElement | null>) => {
    return containerRef?.current?.getElementsByClassName('item selected')?.[0] as
        | HTMLElement
        | undefined;
};
